import { useEffect, useState } from "react";
import Modal from "../../../ReusableComponents/Modal";
import DateTimePicker from "../../../ReusableComponents/DateTimePicker";
import { Button } from "../../../Components/Helper";
import { GLOBAL_STYLES } from "../../../appConstants";
import SelectComponent from "../../../ReusableComponents/SelectComponent";
import Tippy from "@tippyjs/react";
import { useSelector } from "react-redux";

const IssueDashboardFilter = ({ filter, onFilterChange, open, onClose }) => {

  const userDetails = useSelector(state => state.user?.user)

    const [Filter, setFilter] = useState(filter);
    const [Telecaller, setTelecaller] = useState([]);

    const handleFilterChange = (updatedFilter) => {
        setFilter(updatedFilter);
    };

    useEffect(()=>{
        console.log(filter)
        setFilter((prev)=>({...prev,Substatus:filter.Substatus}))
        
    },[])
    

    

    let status = [{ label: "Completed", value: "Completed" }, { label: "Disconnected", value: "Disconnected" }
        , { label: "Incomplete", value: "Incomplete" }, { label: "No Response", value: "No Response" }, { label: "Couldn't Connect", value: "Couldn't connect" }
    ]

    
    

    return (
        <Modal
            header={"Filter"}
            contentStyle={{ width: "730px", height: "250px" }}
            headingStyle={{ fontSize: "18px", fontWeight: 600 }}
            headerContainerStyle={{ padding: "20px" }}
            open={open}
            onClose={onClose}
        >
            <div style={{ padding: "20px 30px", display: "flex", flexDirection: "column", width: "100%", gap: "20px" }}>
                {/* Date Filter Section */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", gap: "10%" }}>
                    <DateTimePicker
                        title="From"
                        hideNxt={new Date()}
                        selectedDateTime={Filter.fromDate}
                        minTime={new Date().setHours(0, 0, 0, 0)}
                        maxTime={new Date().setHours(23, 59)}
                        onChange={(date) => {
                            handleFilterChange({
                                ...Filter,
                                fromDate: new Date(date).toISOString()
                            });
                        }}
                    />
                    <DateTimePicker
                        title="To"
                        hidePrev={Filter.fromDate}
                        selectedDateTime={Filter.toDate}
                        minTime={new Date(Filter?.fromDate).toDateString() === new Date(Filter?.toDate).toDateString()
                            ? new Date(new Date(Filter.fromDate).setMinutes(new Date(Filter.fromDate).getMinutes() + 1))
                            : new Date().setHours(0, 0, 0, 0)}
                        maxTime={new Date().setHours(23, 59)}
                        onChange={(date) => {
                            console.log("RAW",date)
                            if (new Date(Filter.fromDate) < new Date(date)) {
                                console.log("IF",date)
                                if(!Filter.toDate){
                                    let dates = new Date(date).setHours(23,59)
                                    handleFilterChange({
                                        ...Filter,
                                        toDate: new Date(dates).toISOString()
                                    });
                                }else{
                                    console.log("IFELSE",date)
                                    handleFilterChange({
                                        ...Filter,
                                        toDate: new Date(date).toISOString()
                                    });
                                }
                                
                            } else {
                                let sethour = new Date(new Date(date).setHours(23, 59));

                                
                                console.log("RAWELSE",sethour)
                                handleFilterChange({
                                    ...Filter,
                                    toDate: sethour ? sethour : new Date()
                                })
                            }
                        }}
                        isDisable={!(Filter.fromDate)}
                    />
                </div>


                
                



            </div>
            <div style={{ display: "flex", justifyContent: "space-between", padding: "20px 30px", borderTop: '0.5px solid #BFC8D9' }}>
                <div
                    onClick={async () => {
                        setFilter({
                            fromDate: null,
                            toDate: null,
                            Status: 'open',
                            Substatus:[],
                            currentPage:1,
                            interval:"all"
                        })
                        
                        // onFilterChange(Filter)
                    }} style={{ width: "100px", color: GLOBAL_STYLES.BG_ACTIVE, fontWeight: 600, fontSize: "14px", cursor: 'pointer', display: "flex", alignItems: "center", justifyContent: "start" }}>
                    Clear all
                </div>
                <Button
                    text={"Apply"}
                    style={{ width: "130px", height: "38px", fontSize: "15px", marginRight: "10px" }}
                    onClick={() => {
                        onFilterChange(Filter)
                    }}
                />
            </div>
        </Modal>
    );
};

export default IssueDashboardFilter;